import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17703 Сверстать страницу Доступные мне в документах */
export const showAllDocumentsIncomingPublic = isFeature('alldocuments-incoming-public');
